export const isVowel = (chars: string | undefined) => {
  const firstLetter = chars?.toLowerCase().at(0);

  return firstLetter && ['a', 'e', 'i', 'o', 'u'].includes(firstLetter);
};
